import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth',
    method: 'post',
    data
  })
}

export function getInfo(query) {
  return request({
    url: '/auth-info',
    method: 'get',
    params: query
  })
}

export function logout(query) {
  return request({
    url: '/logout',
    method: 'get',
    params: query
  })
}

export function getDictList(query) {
  return request({
    url: '/dict',
    method: 'get',
    params: query
  })
}

export function fetchLanguage(query) {
  return request({
    url: '/language',
    method: 'get',
    params: query
  })
}
